import { Box, Paper, Stack, Typography } from "@mui/material"
import NumberFunctions from "../../../../core/functions/NumberFunctions"
import { useMemo } from "react"
import { useCheckoutContext } from "../../../../core/hooks/useCheckoutContext"
import { checkoutPayment6Style } from "./Payment/PaymentConsts"
import CheckoutHeader6 from "./CheckoutHeader"

const CheckoutCoverImage6 = () => {
  const { productPrice } = useCheckoutContext()

  const values = useMemo(
    () => ({
      people: NumberFunctions.getRandomInt(10) + 4,
      paymentMethodsHtml: productPrice?.paymentMethods.map((pm, index) => {
        let concat = ""
        if (index < productPrice?.paymentMethods.length - 2) concat = ", "
        else if (index === productPrice?.paymentMethods.length - 2)
          concat = " ou "

        return (
          <>
            <b>{checkoutPayment6Style[pm.methodType].label}</b>
            {concat}
          </>
        )
      }),
    }),
    [productPrice?.paymentMethods]
  )

  return (
    <>
      <CheckoutHeader6 />
      <Stack
        direction="column"
        spacing={2}
        sx={{ px: { xs: 1, sm: 3 }, pt: 3 }}
      >
        <Paper
          elevation={0}
          sx={{ p: 2, backgroundColor: "#fde3e2", borderRadius: "10px" }}
        >
          <Stack direction="row" alignItems="center" justifyContent="center">
            <Typography
              color="#ff3b30"
              fontSize={{ xs: "16px", sm: "18px" }}
              lineHeight={{ xs: "16px", sm: "22px" }}
              fontWeight={800}
            >
              Últimos dias de desconto
            </Typography>
          </Stack>
        </Paper>
        <Stack direction="row" spacing={1} alignItems="center" sx={{ p: 1 }}>
          <img src="/assets/layouts/v6/icon-visibility.svg" alt="visibility" />
          <Typography
            color="#464A5A"
            fontSize={{ xs: "16px", sm: "20px" }}
            lineHeight={{ xs: "16px", sm: "26px" }}
            fontWeight={500}
          >
            {values.people} Pessoas <b>estão vendo esse</b> produto agora
          </Typography>
        </Stack>
        <Paper
          elevation={0}
          sx={{ p: 2, backgroundColor: "#d3f3db", borderRadius: "10px" }}
        >
          <Stack
            direction="row"
            spacing={2}
            alignItems="center"
            justifyContent="center"
          >
            <Stack
              height="72px"
              width="72px"
              alignItems="center"
              justifyContent="center"
            >
              <img src="/assets/layouts/v6/icon-pay-pix.svg" alt="pay-pix" />
            </Stack>
            <Typography
              color="#464A5A"
              fontSize={{ xs: "18px", sm: "24px" }}
              lineHeight={{ xs: "18px", sm: "32px" }}
              fontWeight={500}
            >
              Aceitamos pagamento no {values.paymentMethodsHtml}
            </Typography>
          </Stack>
        </Paper>
      </Stack>
    </>
  )
}

export default CheckoutCoverImage6
